import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import MatchCard from "../components/MatchCard"
import { getMatches, getUserCompletedMatches } from "../services/matchService"
import BottomNav from "../components/BottomNav"

const EmptyState = ({ type, onSwitch }) => {
  const configs = {
    upcoming: { title: "No Upcoming Matches", icon: "🕒", sub: "Check back later for new match schedules." },
    live: { title: "No Live Matches", icon: "🏟️", sub: "Currently, no matches are in progress. Browse upcoming matches!" },
    completed: { title: "No Results Found", icon: "🏆", sub: "Results from the last 6 hours are shown here." }
  }[type] || { title: "No Matches Found", icon: "🔍", sub: "Try switching tabs." }

  return (
    <div className="flex flex-col items-center justify-center py-24 px-10 text-center animate-fade-in min-h-[60vh]">
       <div className="w-24 h-24 bg-theme-card rounded-full flex items-center justify-center text-4xl mb-8 shadow-theme-sm border border-theme-border">
          <span className="relative z-10 opacity-40">{configs.icon}</span>
       </div>
       <h3 className="text-base font-bold uppercase text-theme-text tracking-widest mb-3 opacity-80">{configs.title}</h3>
       <p className="text-theme-text-sec text-[10px] font-bold uppercase tracking-wider mb-10 max-w-[280px] leading-relaxed opacity-60">{configs.sub}</p>
       
       {type !== "upcoming" && (
         <button 
           onClick={() => onSwitch("upcoming")}
           className="bg-accent text-white font-bold px-8 py-3 rounded-xl text-[10px] uppercase tracking-widest shadow-sm active:scale-95 transition-all"
         >
           Browse Matches
         </button>
       )}
    </div>
  )
}

const Leagues = () => {
  const [matches, setMatches] = useState([])
  const [completedMatches, setCompletedMatches] = useState([])
  const [tab, setTab] = useState("upcoming")
  const [page, setPage] = useState(1)

  const navigate = useNavigate()

  useEffect(() => {
    fetchMatches()
  }, [tab, page])

  const fetchMatches = async () => {
    try {
      if (tab === "completed") {
        // 🎯 Sirf user ke joined completed matches fetch karo
        const res = await getUserCompletedMatches(page)
        if (page === 1) {
          setCompletedMatches(res.data)
        } else {
          setCompletedMatches(prev => [...prev, ...res.data])
        }
      } else {
        const res = await getMatches(page, tab)
        if (page === 1) {
          setMatches(res.data)
        } else {
          setMatches(prev => [...prev, ...res.data])
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 🔥 filter - completed tab ke liye alag state
  const filteredMatches = tab === "completed"
    ? (completedMatches || [])
    : (matches || []).filter(m => m && m.status?.toLowerCase() === tab.toLowerCase())

  const handleTabSwitch = (newTab) => {
    setTab(newTab)
    setPage(1)
    if (newTab === "completed") {
      setCompletedMatches([]) // Clear completed on tab switch
    } else {
      setMatches([]) // Clear for fresh fetch UI
    }
  }

  return (
    <div className="bg-theme-bg text-theme-text min-h-screen pb-16">

      {/* 🔝 TOP BAR (Consistant with Home) */}
      <div className="flex items-center justify-between p-4 bg-theme-card border-b border-theme-border sticky top-0 z-[60] shadow-theme-sm">
        <button 
          onClick={() => navigate("/")} 
          className="w-10 h-10 flex items-center justify-center bg-theme-bg rounded-xl border border-theme-border text-theme-text transition-all active:scale-95 shadow-theme-sm"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <h1 className="text-lg font-bold text-theme-text tracking-tight uppercase">Leagues</h1>
        <button 
          onClick={() => navigate("/wallet")}
          className="w-10 h-10 flex items-center justify-center bg-accent/10 rounded-xl border border-accent/20 text-accent active:scale-90 transition-all"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 7H5C3.89543 7 3 7.89543 3 9V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 11V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 7V5C7 4.46957 7.21071 3.96086 7.58579 3.58579C7.96086 3.21071 8.46957 3 9 3H15C15.5304 3 16.0391 3.21071 16.4142 3.58579C16.7893 3.96086 17 4.46957 17 5V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {/* 🔥 NEW PROMO BANNER (Minimal Look) */}
      <div className="px-5 pt-5 pb-2">
        <div
          onClick={() => navigate("/player-performance")}
          className="relative w-full rounded-theme p-5 cursor-pointer overflow-hidden group border border-theme-border shadow-theme-sm bg-theme-card"
        >
          <div className="relative z-10 flex items-center justify-between">
            <div className="flex-1">
              <span className="bg-accent text-white text-[8px] font-bold px-2 py-0.5 rounded uppercase tracking-widest mb-1.5 inline-block">New</span>
              <h3 className="text-theme-text font-bold text-base tracking-tight leading-tight uppercase">Ab Team ke Saath<br />Player pe bhi Jeeto!</h3>
              <p className="text-accent text-[9px] mt-1 font-bold uppercase tracking-wider">Predict & Win Big 💰</p>
            </div>
            <div className="w-16 h-16 flex items-center justify-center relative">
              <img src="/leagues_promo_icon.png" alt="Leagues" className="w-16 h-16 object-contain drop-shadow-theme-sm" />
            </div>
          </div>
        </div>
      </div>

      {/* 🔥 TABS */}
      <div className="flex justify-around bg-theme-card border-b border-theme-border">
        {["upcoming", "live", "completed"].map(t => (
          <button
            key={t}
            onClick={() => handleTabSwitch(t)}
            className={`py-3.5 px-4 capitalize text-[10px] font-bold tracking-widest transition-all relative ${
              tab === t ? "text-accent" : "text-theme-text-sec opacity-60"
            }`}
          >
            {t}
            {tab === t && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent"></div>}
          </button>
        ))}
      </div>

      {/* 🔥 MATCH LIST */}
      <div className="p-4 space-y-4">
        {!filteredMatches || filteredMatches.length === 0 ? (
          <EmptyState type={tab} onSwitch={handleTabSwitch} />
        ) : (
          <div className="grid grid-cols-1 gap-4">
            {filteredMatches.map(match => (
              <MatchCard key={match?.match_id || match?.id} match={match} />
            ))}
          </div>
        )}
      </div>

      {/* 🔥 LOAD MORE */}
      {matches.length > 0 && filteredMatches.length > 0 && (
        <div className="px-4 pb-8">
           <button
            onClick={() => setPage(prev => prev + 1)}
            className="w-full bg-theme-card text-theme-text-sec font-bold py-3.5 uppercase text-[10px] tracking-widest rounded-xl border border-theme-border active:scale-95 transition-all shadow-theme-sm"
          >
            Load More Matches
          </button>
        </div>
      )}

      {/* 🔻 BOTTOM NAVBAR */}
      <BottomNav activeTab="leagues" />

      {/* 🎨 ANIMATIONS */}
      <style>{`
        @keyframes swingTip {
          0% { transform: translate(-8px, -8px) rotate(-15deg) scale(0.9); }
          45% { transform: translate(2px, 12px) rotate(0deg) scale(1.1); }
          50% { transform: translate(4px, 14px) rotate(5deg) scale(1.15); filter: brightness(1.2); }
          100% { transform: translate(12px, -12px) rotate(20deg) scale(0.85); }
        }
        .animate-ball-swing {
          animation: swingTip 1.8s ease-in-out infinite alternate;
        }
      `}</style>
    </div>
  )
}

export default Leagues